module.exports = __webpack_public_path__ + "img/D201410_1.08760601.jpg";